import { render, staticRenderFns } from "./VideoSkeleton.vue?vue&type=template&id=6100ef85&scoped=true"
import script from "./VideoSkeleton.vue?vue&type=script&lang=js"
export * from "./VideoSkeleton.vue?vue&type=script&lang=js"
import style0 from "./VideoSkeleton.vue?vue&type=style&index=0&id=6100ef85&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6100ef85",
  null
  
)

export default component.exports